export default "__VITE_ASSET__B8S$SMuT__"